const { toDraft } = require('../../tools')
const removeReport = require('./remove')

module.exports = async (state, {
  reportId
}) => {
  const draftId = toDraft(reportId)
  return removeReport(state, { reportId: draftId })
}
